/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withContext from 'app/withContext';
import * as selectors from 'devices/devices-selectors';
import { getObservationConnections } from 'profile-observation-connections/selectors';
import { isIphone, isAndroid, isMobile, openRouteInApp, isGooglefitEnabled, openMobileRoute, isIOS } from 'mobile/helpers';
import local from 'services/localization/local';
import { DataLoadingStatus, NoDataPlaceholder, Card, BackAction, Button } from 'shared';
import { loadDevices, loadConnectedDevices, getTerraTokenAndConnect, getTerraConnectionUrl, loadTerraDevices, loadActiveDevices } from 'devices/devices-actions';
import { routePaths } from 'services/routing';
import { bindActionCreators } from 'redux';
import ProfilePage from 'profiles/page/ProfilePage';
import withNavigate from 'app/withNavigation';
import { getValidicHealthKitConnectUrl } from 'devices/devices-selectors';
import { mobileAppRoot } from 'app/config';
import ConnectDeviceList from './ConnectDeviceList';
import { AppleHealthType, AppleHealthParam, DeviceData, GoogleFitType, FromGoogleFitConnect, terraProvider, GoalCategoryId } from 'services/constants';
import { getDevices, getFilteredDevices, handleBack } from 'devices/device-helper';
import './devices.scss';
import { baseUrl } from 'services/url-service';
import ObservationConnectedDevices from 'profile-observation-connections/ObservationConnectedDevices';
import DeviceSurvey from './DeviceSurvey';
import { Redirect } from 'react-router-dom';
import { getSubscription, SubsriptionType } from 'preferences/billing/Subscription';
import EncounterIcon from 'shared/fullColorIcons/svgs/encounters.svg';
import { id } from 'chartjs-plugin-zoom';
import { getIsOrgMember } from 'identity/selectors';



class ConnectDevices extends Component {
  constructor(props) {
    super(props);
    this.terraConnect = this.terraConnect.bind(this);
    this.openRoute = this.openRoute.bind(this);
    this.checkDeviceConnected = this.checkDeviceConnected.bind(this);
    this.CheckGoogleFitConnected = this.CheckGoogleFitConnected.bind(this);
    this.doPayment = this.doPayment.bind(this);
    this.state = {
      googleFitConnected: false,
      redirect: false,
      isFreetire: true,
      isOrgMember: props.isOrgMember ?? false
      // isDisabled:false
    };

  }

  componentDidMount() {
    const { showHealthKit, actions, profileId, isOrgMember } = this.props;
    getDevices(this.props);
    console.log('isOrgMember from props:', isOrgMember);
    actions.loadActiveDevices(profileId);
    if (showHealthKit || isAndroid) {
      this.getConnectedDevices();
    }
    const currentSubscription = getSubscription();
    this.setState({
      isFreetire: currentSubscription.type === SubsriptionType.Free,
      isOrgMember: isOrgMember ?? false
    }, () => {
      console.log('isOrgMember from state:', this.state.isOrgMember);
    });
  }


  componentWillUnmount() {
    clearInterval(this.timeoutId);
  }

  doPayment() {
    this.setState({ redirect: true });
  }


  openRoute(type, url, provider) {
    const { connectedDevices, navigate, healthKitUrl, googleFitUrl, actions, profileId } = this.props;
    const connectDeviceUrl = url && decodeURIComponent(url).substring(url.indexOf('?') + 1);
    const urlParams = new URLSearchParams(connectDeviceUrl);
    const observationType = urlParams.get('observationType');
    const source = urlParams.get('source');
    let goalCategoryId = urlParams.get(GoalCategoryId);

    goalCategoryId = (goalCategoryId === undefined || goalCategoryId === null || goalCategoryId === 'null') ? '' : goalCategoryId;

    let isFromObservationConnectPage = false;
    if (url.toString().includes('observationType')) {
      isFromObservationConnectPage = true;
    } else {
      isFromObservationConnectPage = false;
    }

    if (type === AppleHealthType) {
      actions.getTerraTokenAndConnect(profileId);
      let navigateBack = false;
      setTimeout(() => { navigateBack = true; }, 90000);

      if (connectedDevices && connectedDevices.find(d => d.type === AppleHealthType && d.connected === true)) {
        if (isFromObservationConnectPage) {
          navigate({ to: `${routePaths.observationConnect}?observationType=${observationType}&source=${source}&goalCategoryId=${goalCategoryId}` });
        } else {
          navigate({ to: `${routePaths.healthDevices}?${AppleHealthParam}=true` });
        }
        return;
      }
      //  this.getConnectedDevices();
      this.checkDeviceConnected(navigateBack, isFromObservationConnectPage, observationType, source, goalCategoryId);
    }
    else if (type === GoogleFitType) {
      openMobileRoute(googleFitUrl);
      this.getConnectedDevices();
      if (isFromObservationConnectPage) {
        this.CheckGoogleFitConnected(200, observationType, source, goalCategoryId);
      } else {
        setTimeout(() => { navigate({ to: `${routePaths.healthDevices}?${FromGoogleFitConnect}=true` }); }, 2000);
      }

    }
    else if (provider === terraProvider) {
      this.terraConnect(type, isFromObservationConnectPage, observationType, goalCategoryId ?? '');
    }
    else {
      if (isMobile) {
        openRouteInApp(url);
      }
      else {
        window.location.href = url;
      }
    }
  }



  CheckGoogleFitConnected(checkCount, observationType, source, goalCategoryId) {
    const { actions, profileId, validicUserId, navigate } = this.props;

    this.timeoutId = setTimeout(async () => {

      if (isAndroid) {
        const value = true;


        if (value == true) {
          clearTimeout(this.timeoutId);
          navigate({ to: `${routePaths.observationConnect}?observationType=${observationType}&source=${source}&goalCategoryId=${goalCategoryId}` });
          return;
        }
        else {
          checkCount = checkCount - 1;
          if (checkCount > 0) {
            actions.loadConnectedDevices(profileId);
            this.CheckGoogleFitConnected(checkCount, observationType, source, goalCategoryId);
          }
        }
      }

    }, 2000);
    return () => clearTimeout(this.timeoutId);

  }
  checkDeviceConnected(navigateBack, isFromObservationConnectPage, observationType, source, goalCategoryId) {
    const { navigate } = this.props;
    this.timeoutId = setTimeout(() => {
      this.getConnectedDevices().then(() => {
        const _connectedDevices = this.props.connectedDevices;
        if (navigateBack || _connectedDevices) {
          const appleHealth = _connectedDevices?.find(d => d.type === AppleHealthType && d.connected === true);
          if (navigateBack || appleHealth) {
            clearTimeout(this.timeoutId);
            if (isFromObservationConnectPage) {
              navigate({ to: `${routePaths.observationConnect}?observationType=${observationType}&source=${source}&goalCategoryId=${goalCategoryId}` });
            } else {
              navigate({ to: `${routePaths.healthDevices}?${AppleHealthParam}=${appleHealth ? true : false}` });
            }
            return;
          }
        }
      });
      this.checkDeviceConnected(navigateBack, isFromObservationConnectPage, observationType, source, goalCategoryId);
    }, 3000);
    return () => clearTimeout(this.timeoutId);
  }

  async getConnectedDevices() {
    const { actions, profileId, validicUserId } = this.props;

    actions.loadConnectedDevices(profileId);

    // Checking Google Fit Connected
    if (isAndroid) {
      const value = await isGooglefitEnabled(validicUserId);
      this.setState({ googleFitConnected: true });
    }

  }

  terraConnect(deviceSourceName, isFromObservationConnectPage, observationType, goalCategoryId) {
    const { actions, profileId } = this.props;

    let params = `fromTerra=true&profile_Id=${profileId}&source=${deviceSourceName}`;
    if (isFromObservationConnectPage) {
      params = `${params}&observationType=${observationType}&isProfileConnect=true&goalCategoryId=${goalCategoryId}`;
    }
    else {
      params = `${params}&isProfileConnect=false&observationType=0&goalCategoryId=`;
    }

    let redirectUrl = `${baseUrl}/health/devices?${params}`;

    if (isMobile) {
      redirectUrl = `${mobileAppRoot}${DeviceData}?${params}`;
    }

    actions.getTerraConnectionUrl(profileId, deviceSourceName, redirectUrl);
  }

  renderList(sources) {
    const { goalCategoryId } = this.props;
    const programId = this.props?.location?.state?.backpath?.programId;
    const observationType = this.props?.location?.state?.backpath?.observationType;
    const isFromObservationConnectPage = this.props?.location?.state?.backpath?.fromPath === routePaths.observationConnect;
    return (
      <ConnectDeviceList goalCategoryId={goalCategoryId} isFreetire={this.state.isFreetire} isOrgMember={this.state.isOrgMember} sources={sources} programId={programId} observationType={observationType} isFromObservationConnectPage={isFromObservationConnectPage} googleFitConnected={this.state.googleFitConnected} openRoute={this.openRoute}></ConnectDeviceList>
    );
  }



  render() {
    const { devices, deviceLoading, validicUserId, goalCategoryId } = this.props;
    const filteredDevices = getFilteredDevices(this.props, this.state.googleFitConnected);
    const isFromObservationConnectPage = this.props?.location?.state?.backpath?.fromPath === routePaths.observationConnect;
    const programId = this.props?.location?.state?.backpath?.programId;
    const deviceSourceName = this.props?.location?.state?.backpath?.deviceSourceName;
    const observationType = this.props?.location?.state?.backpath?.observationType;
    const title = this.props?.location?.state?.backpath?.observationType ? local.formatString(local.observationConnect.connectTitleText, local.observationsTitle[this.props?.location?.state?.backpath?.observationType]) : local.devices.connectDevices;
    const goalName = this.props?.location?.state?.backpath?.goalName;

    const deviceData = [
      {
        "deviceSourceName": "MACROSFIRST",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/macrosfirst.png",
        "isActive": true,
        "deviceDisplayName": "MacrosFirst",
        "connectUrl": null
      },
      {
        "deviceSourceName": "garmin",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/garmin.png",
        "isActive": true,
        "deviceDisplayName": "Garmin Connect",
        "connectUrl": null
      },
      {
        "deviceSourceName": "XOSS",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/xoss.png",
        "isActive": true,
        "deviceDisplayName": "XOSS",
        "connectUrl": null
      },
      {
        "deviceSourceName": "HEALTHGAUGE",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/healthgauge.png",
        "isActive": true,
        "deviceDisplayName": "Health Gauge",
        "connectUrl": null
      },
      {
        "deviceSourceName": "TECHNOGYM",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/technogym.png",
        "isActive": true,
        "deviceDisplayName": "Technogym",
        "connectUrl": null
      },
      {
        "deviceSourceName": "MAPMYTRACKS",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/mapmytracks.png",
        "isActive": true,
        "deviceDisplayName": "MapMyTracks",
        "connectUrl": null
      },
      {
        "deviceSourceName": "TRAINERROAD",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/trainerroad.png",
        "isActive": true,
        "deviceDisplayName": "TrainerRoad",
        "connectUrl": null
      },
      {
        "deviceSourceName": "MYFITNESSPAL",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/myfitnesspal.png",
        "isActive": true,
        "deviceDisplayName": "MyFitness Pal",
        "connectUrl": null
      },
      {
        "deviceSourceName": "CARDIOMOOD",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/cardiomood.png",
        "isActive": true,
        "deviceDisplayName": "Cardiomood",
        "connectUrl": null
      },
      {
        "deviceSourceName": "BRYTONSPORT",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/brytonsport.png",
        "isActive": true,
        "deviceDisplayName": "Bryton Sport",
        "connectUrl": null
      },
      {
        "deviceSourceName": "DECATHLON",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/technogym.png",
        "isActive": true,
        "deviceDisplayName": "Decathlon",
        "connectUrl": null
      },
      {
        "deviceSourceName": "TENOVI",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/tenovi.png",
        "isActive": true,
        "deviceDisplayName": "Tenovi",
        "connectUrl": null
      },
      {
        "deviceSourceName": "polar",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/polar.png",
        "isActive": true,
        "deviceDisplayName": "Polar",
        "connectUrl": null
      },
      {
        "deviceSourceName": "TODAYSPLAN",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/todaysplan.png",
        "isActive": true,
        "deviceDisplayName": "Today`s Plan",
        "connectUrl": null
      },
      {
        "deviceSourceName": "CLUE",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/clue.png",
        "isActive": true,
        "deviceDisplayName": "Clue app",
        "connectUrl": null
      },
      {
        "deviceSourceName": "NOLIO",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/nolio.png",
        "isActive": true,
        "deviceDisplayName": "Nolio",
        "connectUrl": null
      },
      {
        "deviceSourceName": "BIOSTRAP",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/biostrap.png ",
        "isActive": true,
        "deviceDisplayName": "Biostrap",
        "connectUrl": null
      },
      {
        "deviceSourceName": "KETOMOJOEU",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/ketomojoeu.png",
        "isActive": true,
        "deviceDisplayName": "Ketomojo (EU)",
        "connectUrl": null
      },
      {
        "deviceSourceName": "huawei",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/huawei.png",
        "isActive": true,
        "deviceDisplayName": "Huawei",
        "connectUrl": null
      },
      {
        "deviceSourceName": "VIRTUAGYM",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/virtuagym.png",
        "isActive": true,
        "deviceDisplayName": "Virtuagym",
        "connectUrl": null
      },
      {
        "deviceSourceName": "LIVEROWING",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/liverowing.png",
        "isActive": true,
        "deviceDisplayName": "Liverowing",
        "connectUrl": null
      },
      {
        "deviceSourceName": "TREDICT",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/tredict.png",
        "isActive": true,
        "deviceDisplayName": "Tredict",
        "connectUrl": null
      },
      {
        "deviceSourceName": "ZEPP",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/zepp.png",
        "isActive": true,
        "deviceDisplayName": "Zepp",
        "connectUrl": null
      },
      {
        "deviceSourceName": "concept2",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/concept2.png",
        "isActive": true,
        "deviceDisplayName": "Concept2",
        "connectUrl": null
      },
      {
        "deviceSourceName": "STRAVA",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/strava.png",
        "isActive": true,
        "deviceDisplayName": "strava",
        "connectUrl": null
      },
      {
        "deviceSourceName": "dexcom",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/dexcom.png",
        "isActive": true,
        "deviceDisplayName": "Dexcom",
        "connectUrl": null
      },
      {
        "deviceSourceName": "OMRONUS",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/omron.png",
        "isActive": true,
        "deviceDisplayName": "Omron (US)",
        "connectUrl": null
      },
      {
        "deviceSourceName": "FLO",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/flo.png",
        "isActive": true,
        "deviceDisplayName": "Flo",
        "connectUrl": null
      },
      {
        "deviceSourceName": "CATAPULTONE",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/catapultone.png",
        "isActive": true,
        "deviceDisplayName": "Catapult One",
        "connectUrl": null
      },
      {
        "deviceSourceName": "INSIDERS",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/insiders.png",
        "isActive": true,
        "deviceDisplayName": "Insiders",
        "connectUrl": null
      },
      {
        "deviceSourceName": "CORE",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/core.png",
        "isActive": true,
        "deviceDisplayName": "Core",
        "connectUrl": null
      },
      {
        "deviceSourceName": "TRIDOT",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/tridot.png",
        "isActive": true,
        "deviceDisplayName": "Tridot",
        "connectUrl": null
      },
      {
        "deviceSourceName": "coros",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/coros.png",
        "isActive": true,
        "deviceDisplayName": "Coros",
        "connectUrl": null
      },
      {
        "deviceSourceName": "ifit",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/ifit.png",
        "isActive": true,
        "deviceDisplayName": "iFit",
        "connectUrl": null
      },
      {
        "deviceSourceName": "RIDEWITHGPS",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/ridewithgps.png",
        "isActive": true,
        "deviceDisplayName": "RideWithGPS",
        "connectUrl": null
      },
      {
        "deviceSourceName": "zwift",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/zwift.png",
        "isActive": true,
        "deviceDisplayName": "Zwift",
        "connectUrl": null
      },
      {
        "deviceSourceName": "fatsecret",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/fatsecret.png",
        "isActive": true,
        "deviceDisplayName": "FatSecret",
        "connectUrl": null
      },

      {
        "deviceSourceName": "LEZYNE",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/lezyne.png",
        "isActive": true,
        "deviceDisplayName": "Lezyne",
        "connectUrl": null
      },
      {
        "deviceSourceName": "PUL",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/pul.png",
        "isActive": true,
        "deviceDisplayName": "PUL",
        "connectUrl": null
      },
      {
        "deviceSourceName": "WGER",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/wger.png",
        "isActive": true,
        "deviceDisplayName": "wger",
        "connectUrl": null
      },
      {
        "deviceSourceName": "CYCLINGANALYTICS",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/cyclinganalytics.png",
        "isActive": true,
        "deviceDisplayName": "Cycling Analytics",
        "connectUrl": null
      },
      {
        "deviceSourceName": "samsung",
        "healthDataSource": 2,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/samsung.png",
        "isActive": true,
        "deviceDisplayName": "Samsung Health",
        "connectUrl": null
      },
      {
        "deviceSourceName": "fitbit",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/fitbit.png",
        "isActive": true,
        "deviceDisplayName": "Fitbit",
        "connectUrl": null
      },
      {
        "deviceSourceName": "nutracheck",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/nutracheck.png",
        "isActive": true,
        "deviceDisplayName": "Nutracheck",
        "connectUrl": null
      },
      {
        "deviceSourceName": "INBODY",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/inbody.png",
        "isActive": true,
        "deviceDisplayName": "InBody",
        "connectUrl": null
      },
      {
        "deviceSourceName": "trainingpeaks",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/trainingpeaks.png",
        "isActive": true,
        "deviceDisplayName": "TrainingPeaks",
        "connectUrl": null
      },
      {
        "deviceSourceName": "HAMMERHEAD",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/hammerhead.png",
        "isActive": true,
        "deviceDisplayName": "Hammerhead Karoo",
        "connectUrl": null
      },
      {
        "deviceSourceName": "KETOMOJOUS",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/ketomojous.png",
        "isActive": true,
        "deviceDisplayName": "Ketomojo (US)",
        "connectUrl": null
      },
      {
        "deviceSourceName": "TRAINASONE",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/trainasone.png",
        "isActive": true,
        "deviceDisplayName": "TrainAsOne",
        "connectUrl": null
      },
      {
        "deviceSourceName": "freeStyleLibre",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/librelogo.png",
        "isActive": true,
        "deviceDisplayName": "FreeStyle Libre",
        "connectUrl": null
      },
      {
        "deviceSourceName": "whoop",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/whoop.png",
        "isActive": true,
        "deviceDisplayName": "WHOOP",
        "connectUrl": null
      },
      {
        "deviceSourceName": "omron",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/omron.png",
        "isActive": true,
        "deviceDisplayName": "Omron",
        "connectUrl": null
      },
      {
        "deviceSourceName": "FINALSURGE",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/finalsurge.png",
        "isActive": true,
        "deviceDisplayName": "FinalSurge",
        "connectUrl": null
      },
      {
        "deviceSourceName": "MOXY",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/moxy.png",
        "isActive": true,
        "deviceDisplayName": "Moxy Monitor",
        "connectUrl": null
      },
      {
        "deviceSourceName": "DEXCOM_EU",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/dexcom_eu.png",
        "isActive": true,
        "deviceDisplayName": "Dexcom (EU)",
        "connectUrl": null
      },
      {
        "deviceSourceName": "DEXCOM_JP",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/dexcom_jp.png",
        "isActive": true,
        "deviceDisplayName": "Dexcom (JP)",
        "connectUrl": null
      },
      {
        "deviceSourceName": "withings",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/withings.png",
        "isActive": true,
        "deviceDisplayName": "Withings",
        "connectUrl": null
      },
      {
        "deviceSourceName": "cronometer",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/cronometer.png",
        "isActive": true,
        "deviceDisplayName": "Cronometer",
        "connectUrl": null
      },
      {
        "deviceSourceName": "underarmour",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/underarmour.png",
        "isActive": true,
        "deviceDisplayName": "Under Armour",
        "connectUrl": null
      },
      {
        "deviceSourceName": "KOMOOT",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/komoot.png",
        "isActive": true,
        "deviceDisplayName": "Komoot",
        "connectUrl": null
      },
      {
        "deviceSourceName": "suunto",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/suunto.png",
        "isActive": true,
        "deviceDisplayName": "Suunto",
        "connectUrl": null
      },
      {
        "deviceSourceName": "peloton",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/peloton.png",
        "isActive": true,
        "deviceDisplayName": "Peloton",
        "connectUrl": null
      },
      {
        "deviceSourceName": "ROUVY",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/rouvy.png",
        "isActive": true,
        "deviceDisplayName": "Rouvy",
        "connectUrl": null
      },
      {
        "deviceSourceName": "Wahoo",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/wahoo.png",
        "isActive": true,
        "deviceDisplayName": "Wahoo",
        "connectUrl": null
      },
      {
        "deviceSourceName": "ELITEHRV",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/elitehrv.png",
        "isActive": true,
        "deviceDisplayName": "Elite HRV",
        "connectUrl": null
      },
      {
        "deviceSourceName": "VELOHERO",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/velohero.png",
        "isActive": true,
        "deviceDisplayName": "Velo Hero",
        "connectUrl": null
      },
      {
        "deviceSourceName": "XERT",
        "healthDataSource": 4,
        "logoUrl": "https://hcstaticdev.blob.core.windows.net/images/xert.png",
        "isActive": true,
        "deviceDisplayName": "Xert",
        "connectUrl": null
      }
    ];

    return (
      <ProfilePage
        id='devices'
        centerElement={title} readOnlyProfile titleTabText={local.devices.connectDevices} backAction={<BackAction handleBack={() => handleBack(this.props)} />}>
        <DataLoadingStatus loading={deviceLoading} >
          {isFromObservationConnectPage ? <ObservationConnectedDevices goalCategoryId={goalCategoryId} goalName={goalName} validicUserId={validicUserId} programId={programId} deviceSourceName={deviceSourceName} observationType={observationType}></ObservationConnectedDevices> : null}
          {devices && devices !== undefined && devices.length > 0 && !isFromObservationConnectPage ? (
            <Card className="devices-card">
              <ul className="disconnected-devices">{this.renderList(devices)} </ul>
            </Card>) : null}
          {this.state.isFreetire && !this.state.isOrgMember ?
            <div className="devices-card upgrade-card">
              <div className='upgrade-container'>
                <div className='upgrade-quote'>
                  <p>Upgrade your subscription to access various device connections</p>
                </div>
                <div className='upgrade-button'>
                  <button onClick={this.doPayment}>Upgrade</button>
                </div>
                <div className='device-to-upgrade'>
                  <div className='device-inner-container'>
                    {deviceData.map((item) => (
                      <div className='image-container'>
                        <img src={item.logoUrl} alt="" />
                        <p>{item.deviceDisplayName}</p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className='upgrade-button'>
                  <button onClick={this.doPayment}>Upgrade</button>
                </div>
              </div>
              {this.state.redirect ? <Redirect to='/view-plan' /> : null}
            </div> : null}
          {!devices || devices.length === 0 ? <NoDataPlaceholder>{ }</NoDataPlaceholder> : null}
          {filteredDevices && filteredDevices !== undefined && filteredDevices.length > 0 && isFromObservationConnectPage ? (
            <Card className="devices-card">
              <ul className="disconnected-devices">{this.renderList(filteredDevices)} </ul>
            </Card>
          ) : null}
          {isFromObservationConnectPage ?
            <DeviceSurvey
              programId={this.props?.location?.state?.backpath?.programId}
              observationType={this.props?.location?.state?.backpath?.observationType} />
            : null}
        </DataLoadingStatus>
      </ProfilePage>
    );
  }
}


ConnectDevices.propTypes = {
  actions: PropTypes.shape({
    loadDevices: PropTypes.func.isRequired,
    loadConnectedDevices: PropTypes.func.isRequired,
    getTerraConnectionUrl: PropTypes.func.isRequired,
    loadTerraDevices: PropTypes.func.isRequired
  }).isRequired,
  devices: PropTypes.arrayOf(PropTypes.shape()),
  profileId: PropTypes.string.isRequired,
  showHealthKit: PropTypes.bool.isRequired,
  navigate: PropTypes.func,
  healthKitUrl: PropTypes.string,
  googleFitUrl: PropTypes.string,
  deviceLoading: PropTypes.bool.isRequired,
  connectedDevices: PropTypes.arrayOf(PropTypes.shape()),
  isOrgMember: PropTypes.bool
};

function mapStateToProps(state, props) {
  const healthkit = getValidicHealthKitConnectUrl(state, props.profileId);
  const googleFitUrl = selectors.getValidicGoogleFitMobileUrl(state, props.profileId);
  const validicUserId = selectors.getValidicUserId(state, props.profileId);
  // eslint-disable-next-line no-unused-vars
  return {
    devices: selectors.getDisconnectedDevices(state, props.profileId, healthkit),
    healthKitUrl: healthkit,
    googleFitUrl: googleFitUrl,
    deviceLoading: selectors.isgetDisconnectedDevicesLoading(state, props.profileId),
    showHealthKit: isIOS,
    connectedDevices: selectors.getConnectedDevices(state, props.profileId),
    validicUserId: validicUserId,
    observationConnections: getObservationConnections(state),
    goalCategoryId: props?.location?.state?.backpath?.goalCategoryId,
    isOrgMember: getIsOrgMember(state)
  };
}

function mapDispatchToProps(dispatch) {
  const actions = { loadDevices, loadConnectedDevices, getTerraConnectionUrl, loadTerraDevices, loadActiveDevices, getTerraTokenAndConnect };
  return { actions: bindActionCreators(actions, dispatch) };
}
export default withNavigate(withContext(connect(mapStateToProps, mapDispatchToProps)(ConnectDevices)));
